<template>
  <div class="bgray-200 text-left">
    <b-navbar toggleable="sm" type="dark" class="bgray-900 header-nav">
        <b-navbar-brand><router-link to="/"><b-img class="header-logo" src="/images/QESG_Assessment_basic.svg" alt="QESG Assessment"></b-img></router-link></b-navbar-brand>
    </b-navbar>

    <b-container class="py-5">
        <b-btn variant="link" class="pl-0 pt-5 gray-700" @click="goBack">
            <fa icon="arrow-left" class="mr-1"></fa> {{ $t('이전 화면으로') }}
        </b-btn>
        <h2 class="pt-2 mb-4 fw-600"> {{ $t(mode) }} </h2>
        
        <b-card v-if="mode=='이용약관'" class="mb-5">
            <terms-of-use></terms-of-use>
        </b-card>
        <b-card v-else-if="mode=='개인정보 처리방침'" class="mb-5"> 
            <privacy-policy></privacy-policy>
        </b-card>    
    </b-container>

    <div class="w-100 py-2 bgray-700 gray-400 f-90">
        <span class="pl-5"> Copyright <fa icon="copyright" class="mr-2"></fa>{{ year }} </span> <span class="pr-2">QuantifiedESG, Inc.</span> (주)퀀티파이드이에스지
    </div>
  </div>
</template>

<script>
import TermsOfUse from '@shared_components/utils/service_policies/TermsOfUse'
import PrivacyPolicy from '@shared_components/utils/service_policies/PrivacyPolicy'

export default {
    data() {
        return {
            year: new Date().getFullYear()
        }
    },
    computed:{
        // 어떤 문서인지는 주소(?doc=privacy)로 정한다 — 로그아웃 등으로 store 가 비어도 빈 화면이 되지 않는다. 기본 이용약관
        mode(){
            return this.$route.query.doc === 'privacy' ? '개인정보 처리방침' : '이용약관';
        }
    },
    methods:{
        goBack(){
            if (window.history.length > 1) this.$router.back();
            else this.$router.push('/');
        }
    },
    components: {
        TermsOfUse,
        PrivacyPolicy
    }

}
</script>

<style>

</style>